import _defineProperty from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/defineProperty";
import _objectWithoutProperties from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties";
import _asyncToGenerator from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import _classCallCheck from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/createClass";
import _inherits from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
var _excluded = ["selectFormContext"];
import _regeneratorRuntime from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/regenerator";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import { Result } from '@digibricks/domains';
import { AxiosApi } from '@digibricks/plugin-axios';
import { ErrorResultHandler } from '@lib/domain-common';
export var GLOBAL_FORM_API = 'GLOBAL_FORM_API';
export var GlobalFormApi = /*#__PURE__*/function (_AxiosApi) {
  _inherits(GlobalFormApi, _AxiosApi);

  var _super = _createSuper(GlobalFormApi);

  function GlobalFormApi(axiosInstance, globalFormApiMapper) {
    var _this;

    _classCallCheck(this, GlobalFormApi);

    _this = _super.call(this, 'global-forms', axiosInstance);
    _this.axiosInstance = axiosInstance;
    _this.globalFormApiMapper = globalFormApiMapper;
    return _this;
  }

  _createClass(GlobalFormApi, [{
    key: "findMany",
    value: function () {
      var _findMany = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(query) {
        var _this2 = this;

        var _queryParams$tagIds, _parsedResponseBody$d, _ref, _selectFormContext, queryParams, jsonResponse, parsedResponseBody, globalFormsResponse;

        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.prev = 0;
                _ref = query, _selectFormContext = _ref.selectFormContext, queryParams = _objectWithoutProperties(_ref, _excluded);
                _context.next = 4;
                return this.axios.get(this.url, {
                  params: _objectSpread({
                    categoryId: queryParams === null || queryParams === void 0 ? void 0 : queryParams.categoryId,
                    nextToken: queryParams === null || queryParams === void 0 ? void 0 : queryParams.nextToken,
                    limit: queryParams === null || queryParams === void 0 ? void 0 : queryParams.limit,
                    search: queryParams === null || queryParams === void 0 ? void 0 : queryParams.search
                  }, (queryParams === null || queryParams === void 0 ? void 0 : (_queryParams$tagIds = queryParams.tagIds) === null || _queryParams$tagIds === void 0 ? void 0 : _queryParams$tagIds.length) > 0 && {
                    tags: queryParams.tagIds.join(',')
                  })
                });

              case 4:
                jsonResponse = _context.sent;
                parsedResponseBody = jsonResponse.data;

                if (parsedResponseBody.data) {
                  _context.next = 8;
                  break;
                }

                return _context.abrupt("return", Result.fail(parsedResponseBody.message));

              case 8:
                globalFormsResponse = (_parsedResponseBody$d = parsedResponseBody.data.items) === null || _parsedResponseBody$d === void 0 ? void 0 : _parsedResponseBody$d.map(function (item) {
                  return _this2.globalFormApiMapper.toDomain(item);
                });
                return _context.abrupt("return", Result.ok({
                  globalForms: globalFormsResponse,
                  nextToken: parsedResponseBody.data.nextToken || null
                }));

              case 12:
                _context.prev = 12;
                _context.t0 = _context["catch"](0);
                return _context.abrupt("return", ErrorResultHandler(_context.t0));

              case 15:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this, [[0, 12]]);
      }));

      function findMany(_x) {
        return _findMany.apply(this, arguments);
      }

      return findMany;
    }()
  }, {
    key: "convertToNormalForm",
    value: function () {
      var _convertToNormalForm = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(id) {
        var jsonResponse, parsedResponseBody;
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.prev = 0;
                _context2.next = 3;
                return this.axios.put("".concat(this.url, "/").concat(id, "/convert-to-form"));

              case 3:
                jsonResponse = _context2.sent;
                parsedResponseBody = jsonResponse.data;

                if (!(parsedResponseBody.statusCode !== 200)) {
                  _context2.next = 7;
                  break;
                }

                return _context2.abrupt("return", Result.fail(parsedResponseBody.message));

              case 7:
                return _context2.abrupt("return", Result.ok());

              case 10:
                _context2.prev = 10;
                _context2.t0 = _context2["catch"](0);
                return _context2.abrupt("return", ErrorResultHandler(_context2.t0));

              case 13:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this, [[0, 10]]);
      }));

      function convertToNormalForm(_x2) {
        return _convertToNormalForm.apply(this, arguments);
      }

      return convertToNormalForm;
    }()
  }, {
    key: "create",
    value: function () {
      var _create = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3(input) {
        var url, jsonResponse, parsedResponseBody, globalForm;
        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _context3.prev = 0;
                url = "".concat(this.url);
                _context3.next = 4;
                return this.axios.post(url, input);

              case 4:
                jsonResponse = _context3.sent;
                parsedResponseBody = jsonResponse.data;

                if (parsedResponseBody.data) {
                  _context3.next = 8;
                  break;
                }

                return _context3.abrupt("return", Result.fail(parsedResponseBody.message));

              case 8:
                globalForm = this.globalFormApiMapper.toDomain(parsedResponseBody.data);
                return _context3.abrupt("return", Result.ok(globalForm));

              case 12:
                _context3.prev = 12;
                _context3.t0 = _context3["catch"](0);
                return _context3.abrupt("return", ErrorResultHandler(_context3.t0));

              case 15:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this, [[0, 12]]);
      }));

      function create(_x3) {
        return _create.apply(this, arguments);
      }

      return create;
    }()
  }, {
    key: "update",
    value: function () {
      var _update = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4(input) {
        var url, jsonResponse, parsedResponseBody;
        return _regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                _context4.prev = 0;
                url = "".concat(this.url, "/").concat(input.id);
                _context4.next = 4;
                return this.axios.patch(url, input.input);

              case 4:
                jsonResponse = _context4.sent;
                parsedResponseBody = jsonResponse.data;

                if (!(parsedResponseBody.message && !parsedResponseBody.message.toLowerCase().includes('success'))) {
                  _context4.next = 8;
                  break;
                }

                return _context4.abrupt("return", Result.fail(parsedResponseBody.message));

              case 8:
                return _context4.abrupt("return", Result.ok());

              case 11:
                _context4.prev = 11;
                _context4.t0 = _context4["catch"](0);
                return _context4.abrupt("return", ErrorResultHandler(_context4.t0));

              case 14:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, this, [[0, 11]]);
      }));

      function update(_x4) {
        return _update.apply(this, arguments);
      }

      return update;
    }()
  }, {
    key: "getGroupByCategory",
    value: function () {
      var _getGroupByCategory = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee5(input) {
        var _this3 = this;

        var jsonResponse, parsedResponseBody, result;
        return _regeneratorRuntime.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                _context5.prev = 0;
                _context5.next = 3;
                return this.axios.get("".concat(this.url, "/grouped-category"), {
                  params: input
                });

              case 3:
                jsonResponse = _context5.sent;
                parsedResponseBody = jsonResponse.data;

                if (parsedResponseBody.data) {
                  _context5.next = 7;
                  break;
                }

                return _context5.abrupt("return", Result.fail(parsedResponseBody.message));

              case 7:
                result = parsedResponseBody.data.map(function (data) {
                  return {
                    categoryId: data.categoryId,
                    categoryName: data.categoryName,
                    items: data.items.map(function (globalForm) {
                      return _this3.globalFormApiMapper.toDomain(globalForm);
                    })
                  };
                });
                return _context5.abrupt("return", Result.ok(result));

              case 11:
                _context5.prev = 11;
                _context5.t0 = _context5["catch"](0);
                return _context5.abrupt("return", ErrorResultHandler(_context5.t0));

              case 14:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5, this, [[0, 11]]);
      }));

      function getGroupByCategory(_x5) {
        return _getGroupByCategory.apply(this, arguments);
      }

      return getGroupByCategory;
    }()
  }]);

  return GlobalFormApi;
}(AxiosApi);